import '../Inscription.less';
import {Menu , Row, Col} from 'antd';
import { ApartmentOutlined,EyeOutlined, HomeOutlined,FileTextOutlined, TeamOutlined, UserOutlined, LogoutOutlined,} from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import {NavLink} from "react-router-dom";

import {logout,centerStyle} from './utils';

/** *
* *Menu used in all Jury Views
*/
class JuryMenu extends Component {
  render() {  
    const { SubMenu } = Menu;
    return (
        <div>
            <Row>
            <Col><NavLink to="/musicologia/jurado"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row align='bottom'>
          <Col span={3}>
          <h2 style={{fontSize:'20px', fontWeight:'bold', font:'black'}}> {this.props.name}</h2>
          
            
            </Col>
            <Col span={17}>
              <Menu style={centerStyle} mode="horizontal" defaultSelectedKeys={["plays_pres"]}>
                
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/jurado_obras"> Obras en Concurso</NavLink>
                </Menu.Item>
                <Menu.Item key="plays_pres" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/jurado_obras_preseleccionadas"> Obras Preseleccionadas</NavLink>
                </Menu.Item>
        
                <Menu.Item key="plays_final" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
              <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/jurado_obras_finalistas"> Obras Finalistas</NavLink>
            </Menu.Item>
                 
              </Menu>
            </Col>
            <Col span={4}>
              <Menu mode="horizontal" >
          <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
          <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold', font:'black'}}> Cerrar sesión </a>
          </Menu.Item>
          
          </Menu>
            
            </Col>
          </Row>
          </div>
    );
  }
}
export default JuryMenu;


